export const LINECHART_BORDER_COLOR = '#109CF1';
export const LINECHART_BACKGROUND_COLOR = 'rgba(16, 156, 241, 0.2)';
export const LINECHART_DEFAULT_RANGE_DAYS = 30;

export let REL_ROT_1_COLOR = '#000000';
export let REL_ROT_2_COLOR = '#808080';

export function setRelRotColors(color1: string, color2: string) {
	REL_ROT_1_COLOR = color1;
	REL_ROT_2_COLOR = color2;
}

export const tiltSensorChartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	tooltips: {
		backgroundColor: 'rgba(25,42,62,0.6)',
		bodyFontColor: '#FFF',
		borderWidth: 0,
		caretSize: 0,
		colorBody: 'rgba(25,42,62,0.6)',
		bodyFontSize: 14,
		bodyFontStyle: 'bold',
		cornerRadius: 15,
		xPadding: 16,
		yPadding: 8,
		displayColors: false,
		enabled: true,
		intersect: false,
		titleFontSize: 10,
		titleFontStyle: 'regular',
		mode: 'nearest',
		callbacks: {
			title(tooltipItems) {
				return tooltipItems[0].xLabel;
			},
			label(tooltipItem) {
				return tooltipItem.yLabel + 'mm';
			},
		},
	},
	legend: { display: false },
	scales: {
		xAxes: [
			{
				type: 'time',
				ticks: {
					maxRotation: 90,
					minRotation: 90,
				},
				time: {
					displayFormats: {
						hour: 'MMM D HH:mm',
						day: 'MMM D',
						week: 'll',
					},
					stepSize: 3,
					unit: 'hour',
					tooltipFormat: 'MMM DD YYYY, HH:mm:ss',
				},
				gridLines: {
					display: false,
				},
			},
		],
		yAxes: [
			{
				gridLines: {
					borderDash: [8, 4],
				},
				ticks: {
					stepSize: 1,
				},
			},
		],
	},
};
